import React from "react";

const left = <polyline points="15 18 9 12 15 6" />;
const right = <polyline points="9 18 15 12 9 6" />;

const iconMapper: {
  [key: string]: JSX.Element;
} = {
  left: left,
  right: right,
};

const SVG = ({ icon, viewBox }: { icon: string; viewBox: string }) => {
  const strokeWidth = 1;

  return (
    <svg
      className="image-gallery-svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {iconMapper[icon]}
    </svg>
  );
};

export default SVG;
